import React from 'react';
import { Container } from 'reactstrap';

import ColorCard from '../../../ColorCard';

const ITEMS = [
  {
    color: 'blue',
    title: 'DevOps',
    text:
      'Cutting-edge practices and tools for rapid deployment of applications.',
  },
  {
    color: 'dark-blue',
    title: 'Security',
    text: 'Continuous perimeter reviews for piece of mind.',
  },
  {
    color: 'green',
    title: 'Managed Cloud',
    text:
      'Watching over your cloud infrastructure needs.',
  },
  {
    color: 'orange',
    title: 'Solution Architect Ondemand',
    text: 'Extract business insights directly from our cloud engineers.',
  },
  {
    color: 'burnt-orange',
    title: 'Compliance',
    text: 'Recurrent security risk analysis and vulnerability assessments.',
  },
  {
    color: 'lime-green',
    title: 'Modern App Support',
    text: 'Build, deploy, and support your applications with Cloudnexa.',
  },
];

const Expertise = ({ expertiseRef }) => {
  return (
    <section className="Expertise" ref={expertiseRef}>
      <Container>
        <h2 className="Expertise__title">
          Managed Solutions&nbsp;
          <span className="text-dark-blue">Expertise</span>
        </h2>

        <div className="Expertise__list">
          {ITEMS.map((item, idx) => (
            <div
              key={idx}
              className={`${
                idx === ITEMS.length - 1 ? '' : 'mb-4'
              } w-md-50 pl-md-2 pr-md-2 pl-xl-3 pr-xl-3 Expertise__item`}
            >
              <ColorCard {...item} />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Expertise;
